import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, WalletIcon, SmartphoneIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackMetaPixelEvent } from '../../utils/metaPixel';
const rows = [{
  content: 'Colección de Planos y Sistemas (5 Tomos)',
  value: '69€'
}, {
  content: 'Pack de Estrategia y Ventas (5 Bonos)',
  value: '89,50€'
}];
const paymentOptions = [{
  icon: CreditCardIcon,
  label: 'Tarjeta de crédito/débito'
}, {
  icon: WalletIcon,
  label: 'Paypal'
}, {
  icon: SmartphoneIcon,
  label: 'Apple Pay / Google Pay'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantizado por Whop'
}];
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-secondary py-10 sm:py-14" data-id="element-161" data-mp="3a6w7w53uv20">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-162" data-mp="2064dx2n6duoz">
        <div className="rounded-2xl bg-action px-5 py-4 text-center" data-id="element-163" data-mp="2534krfrun1h5">
          <p className="text-xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-164" data-mp="255hboifl4m6c">
            ⚠️ Atención: el precio de 19€ es para ayudar a los primeros 50 artesanos a limpiar su taller
            de retales este mes. Quedan menos de 12 copias a este precio.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-6 max-w-2xl px-4 text-center sm:px-6" data-id="element-165" data-mp="xjbujlia1tyz">
        <SectionTag icon="💰" data-id="element-166" data-mp="xl6eoxlq5i20">Oferta especial de lanzamiento</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-167" data-mp="1u8jdqmvfbqzq">
          ¿Cuánto vale para ti dejar de tirar madera y empezar a facturar?
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-xs px-4 text-center sm:px-6" data-id="element-168" data-mp="1l7l8y2d5vfg3">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/e51e3ed3-6ced-4eaa-b5b2-2bee3f15d2ca.jpg" alt="Carpintero mirando con esperanza un montón de retales de madera en su taller" loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-2xl border border-brown/20 object-cover shadow-card" data-id="element-169" data-mp="1gamibtsphqmn" />
        <p className="mt-3 text-sm italic text-muted" data-id="element-170" data-mp="bao8aa6zkvps">
          No son sobras, es tu próximo sueldo. Solo te faltaba el plano.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-171" data-mp="3tfzujz03yz77">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-brown/30 bg-white p-6 shadow-card sm:p-7" data-id="element-172" data-mp="1c7d1110luxx">
          <p className="font-heading text-xs font-bold uppercase tracking-wider text-muted" data-id="element-173" data-mp="39t283ubkmb1g">
            🔨 El Kit del Taller Rentable
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-174" data-mp="3erwq4u1prvki">5 tomos + 5 bonos, listos para fabricar y vender.</p>

          <div className="mt-4 space-y-1.5" data-id="element-175" data-mp="30sniiirkq9s5">
            {rows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-brown/10 py-1.5 text-sm" data-id="element-176" data-mp="35px6dtzbeddv">
                <span className="text-ink/80" data-id="element-177" data-mp="2m5f3f6v59kaw">{row.content}</span>
                <span className="flex-shrink-0 text-muted line-through" data-id="element-178" data-mp="2h73vj1oetjvb">{row.value}</span>
              </div>)}
            <div className="flex items-center gap-2 py-1.5 text-sm text-ink/80" data-id="element-179" data-mp="2v6mqstw4h0q7">
              <CheckIcon size={14} className="flex-shrink-0 text-success" data-id="element-180" data-mp="2r404t9m4ua0x" />
              Acceso de por vida a futuras actualizaciones
            </div>
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-ink" data-id="element-181" data-mp="351y5jc7j67xy">
              <span data-id="element-182" data-mp="3033puj4v0zi2">VALOR TOTAL</span>
              <span data-id="element-183" data-mp="3eu3x4ktvencm">158,50€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-184" data-mp="3evnhamindijo">Consíguelo hoy por solo:</p>
          <p className="font-heading text-5xl font-extrabold text-brown sm:text-6xl" data-id="element-185" data-mp="39wu8h7eb2fpu">19€</p>
          <p className="mt-2 text-sm text-danger" data-id="element-186" data-mp="3nsfwbb8sytgo">⏰ Descuento del 88% — solo para los próximos 50 pedidos</p>

          <div className="mt-6" data-id="element-187" data-mp="3itl2zfd7lmib">
            <a href={CHECKOUT_URL} onClick={() => trackMetaPixelEvent('InitiateCheckout', {
            value: 19,
            currency: 'EUR'
          })} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-action px-8 py-4 font-heading text-base font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-action-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-188" data-mp="1h6s11y5zqhaf">
              🔨 Quiero el kit por solo 19€
            </a>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-brown/10 pt-4 text-[11px] text-muted" data-id="element-189" data-mp="176ize4t8c3nn">
            {paymentOptions.map(item => <span key={item.label} className="flex items-center gap-1.5" data-id="element-190" data-mp="2inhobwggiv0d">
                <item.icon size={13} className="flex-shrink-0" data-id="element-191" data-mp="2ipc1golhlitw" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}